<evsb-standard-modal-window [fullHeight]="true">
  <header>
    <evsb-modal-header
      [backLabel]="'modules.evsb.navigation.back' | translate"
      [backEnabled]="canGoBack"
      (back)="goBack()"
    >
      {{ 'modules.evsb.chargingStation.title' | translate }}
    </evsb-modal-header>
  </header>

  <div class="flex px-8 md:px-16 py-6 overflow-y-auto">
    <evsb-charging-station-flow
      class="flex-grow"      
      [model]="inputModel"      
      [hasChosenChargingSpeed]="hasChosenChargingSpeed"
      [wantsAtLeastOneChargingStation]="wantsAtLeastOneChargingStation"
      [hasChosenPlacement]="hasChosenPlacement"
      [hasCompletedFlow]="hasCompletedFlow"
      (solutionChange)="calculateSolutionPrice($event)"
    ></evsb-charging-station-flow>
  </div>

  <footer [@fadeInUp]>
    <evsb-modal-footer>
      <div class="w-full flex flex-col gap-5 -mt-4">
        <div class="flex flex-row justify-between items-center">
          <p class="text-grey-dark text-xs">
            {{ 'modules.evsb.chargingStation.input.yourCombination' | translate }}
          </p>
          <evsb-currency-lg
            [end]="'modules.evsb.chargingStation.input.exclTax' | translate"
            [amount]="solutionPrice$ | async"
          ></evsb-currency-lg>
        </div>
        <evsb-primary-button [fullWidth]="true" [state]="submitBtnState" (click)="add()">
          {{ 'modules.evsb.chargingStation.input.addToSolutions' | translate }}
        </evsb-primary-button>
      </div>
    </evsb-modal-footer>
  </footer>
</evsb-standard-modal-window>
